export default function CErrorHandling() {
  return <h2>C Error Handling</h2>;
}
